import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, DynamicForm, FieldVariant, MultiSelectFieldProps, SelectOption } from '@/components/form-builder/form-builder.types';
import { getSingleFieldObjectFactory } from '@/components/form-builder/utils/single-field-factory';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';

interface getPPMCommiteeDialogProps {
  store: PpmRepository;
  committees: SelectOption[];
  validate: () => void;
}

export const getPPMCommiteeDialog = ({ store, committees, validate }: getPPMCommiteeDialogProps): DialogObject => {
  const committeField: DynamicField<MultiSelectFieldProps> = {
    label: 'ppm.form.committee',
    variant: FieldVariant.SELECT,
    isRequired: true,
    props: {
      placeholder: 'ppm.form.placeholders.committee',
      options: committees,
      value: store.getObservable('comSelected'),
      onSelectChange: (value: any) => {
        store.set('comSelected', value);
        store.setNested('dto', 'comId', value.code);
      },
    },
  };
  const formObject: DynamicForm = getSingleFieldObjectFactory(committeField);
  return {
    title: 'ppm.form.committee',
    actions: [
      {
        label: 'ppm.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
  };
};
